// extracted by mini-css-extract-plugin
module.exports = {"animate":"CopyButton_animate__jH3ta","pop":"CopyButton_pop__2Sd1U"};